import { Map } from 'immutable';
import { connect } from '../../../../common/react-redux';
import { closeModal } from '../../../../common/actions/modal';
import { set as setUI } from '../../../../common/actions/ui';
import QuizEntry from '../../../../common/records/QuizEntry';
import { moveImmutableQuizEntry } from '../../../api/quizEntries';
import { MoveImmutableModal as MoveImmutableModalPresenter } from './presenter';
import { MOVE_IMMUTABLE_MODAL, MOVE_IMMUTABLE_DATA } from '@instructure/quiz-common';
function mapStateToProps(state, props) {
  var _state$getIn$toObject = state.getIn(['ui', MOVE_IMMUTABLE_DATA], Map()).toObject(),
    movedInSidebar = _state$getIn$toObject.movedInSidebar,
    quizId = _state$getIn$toObject.quizId,
    position = _state$getIn$toObject.position,
    stimulusQuizEntryId = _state$getIn$toObject.stimulusQuizEntryId,
    quizEntryId = _state$getIn$toObject.quizEntryId;
  var quizEntry = QuizEntry.create(state.getIn(['quizEntries', quizEntryId]));
  return {
    modalOpen: state.getIn(['modal', 'isOpen']) === MOVE_IMMUTABLE_MODAL,
    movedInSidebar: movedInSidebar,
    quizId: quizId,
    position: position,
    stimulusQuizEntryId: stimulusQuizEntryId,
    quizEntry: quizEntry
  };
}
var mapDispatchToProps = {
  closeModal: closeModal,
  moveImmutableQuizEntry: moveImmutableQuizEntry,
  setUI: setUI
};
export var MoveImmutableModal = connect(mapStateToProps, mapDispatchToProps)(MoveImmutableModalPresenter);
export default MoveImmutableModal;